import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IAutoCompleteData } from '../../interfaces/i-auto-complete-data';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { CommonModule } from '@angular/common';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

@Component({
  selector: 'app-auto-complete',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatInputModule,
  ],
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss'],
})
export class AutoCompleteComponent {
  @Input() searchList: IAutoCompleteData[];
  @Input() isSearching: boolean;
  @Input() searchBarControl: FormControl;
  @Input() placeholder: string = 'Search';

  @Output() handleSelectedResult: EventEmitter<IAutoCompleteData> =
    new EventEmitter();

  onOptionSelected($event) {
    this.handleSelectedResult.emit($event.option.value);
    this.searchBarControl.setValue('');
  }
}
